(function() {
    const initTabs = (rootEl) => {
        const blocks = rootEl.querySelectorAll('.tabs-block-horizontal');

        blocks.forEach(block => {
            const navButtons = block.querySelectorAll('.tabs-block-horizontal__nav-item');
            const tabPanels = block.querySelectorAll('.tabs-block-horizontal__tab-panel');

            if (!navButtons.length || !tabPanels.length) return;
            if (block.dataset.tabsInitialized) return;
            block.dataset.tabsInitialized = 'true';

            // assign unique IDs if missing
            navButtons.forEach((btn, i) => {
                if (!btn.id) btn.id = `tab-btn-${Math.random().toString(36).substr(2, 6)}-${i}`;
            });
            tabPanels.forEach((panel, i) => {
                if (!panel.dataset.id) panel.dataset.id = navButtons[i]?.id || `tab-panel-${i}`;
            });

            const deactivateAll = () => {
                navButtons.forEach(btn => btn.classList.remove('active'));
                tabPanels.forEach(panel => panel.classList.remove('active'));
            };

            const activateTab = (id) => {
                if (!id) return;
                const targetPanel = block.querySelector(`.tabs-block-horizontal__tab-panel[data-id="${CSS.escape(id)}"]`);
                const targetButton = block.querySelector(`.tabs-block-horizontal__nav-item#${CSS.escape(id)}`);

                if (!targetPanel || !targetButton) return;
                deactivateAll();
                targetPanel.classList.add('active');
                targetButton.classList.add('active');
            };

            navButtons.forEach(button => {
                button.addEventListener('click', e => {
                    e.preventDefault();
                    activateTab(button.id);
                });
            });

            // open first tab by default
            if (navButtons[0]) activateTab(navButtons[0].id);
        });
    };

    const initMobileSelects = (rootEl) => {
        const wrappers = rootEl.querySelectorAll('.tabs-block-horizontal__mobile-select .horizontal-select-wrapper-mobile');

        wrappers.forEach(wrapper => {
            const trigger = wrapper.querySelector('.horizontal-select-trigger-mobile');
            const options = wrapper.querySelectorAll('.horizontal-select-options-mobile li');
            const block = wrapper.closest('.tabs-block-horizontal');

            if (!trigger || !options.length || !block) return;

            trigger.addEventListener('click', () => {
                wrapper.classList.toggle('open');
            });

            options.forEach(option => {
                option.addEventListener('click', () => {
                    if (option.classList.contains('horizontal-select-close-mobile')) {
                        wrapper.classList.remove('open');
                        return;
                    }

                    const id = option.dataset.id?.trim();
                    const label = option.textContent;

                    options.forEach(opt => opt.classList.remove('selected'));
                    // add to the clicked one
                    option.classList.add('selected');

                    trigger.textContent = label;
                    wrapper.classList.remove('open');

                    if (id) {
                        const btn = block.querySelector(`.tabs-block-horizontal__nav-item#${CSS.escape(id)}`);
                        if (btn) btn.click();
                    }
                });
            });



            // close if clicked outside
            document.addEventListener('click', e => {
                if (!wrapper.contains(e.target)) {
                    wrapper.classList.remove('open');
                }
            });

            // ✅ set default option (first available one)
            const firstAvailable = Array.from(options).find(opt => {
                const id = opt.dataset.id?.trim();
                const btn = id ? block.querySelector(`.tabs-block-horizontal__nav-item#${CSS.escape(id)}`) : null;
                return btn !== null; // only use if tab actually exists
            });

            if (firstAvailable) {
                const id = firstAvailable.dataset.id?.trim();
                const label = firstAvailable.textContent;
                trigger.textContent = label;
                firstAvailable.classList.add('selected');

                const btn = block.querySelector(`.tabs-block-horizontal__nav-item#${CSS.escape(id)}`);
                if (btn) btn.click();
            }

        });


    };



    document.addEventListener('DOMContentLoaded', () => {
        initTabs(document);
        initMobileSelects(document);
    });

    if (window.wp && window.wp.domReady) {
        wp.domReady(() => {
            const { subscribe, select } = wp.data;
            let prevBlocks = select('core/block-editor').getBlocks();

            subscribe(() => {
                const currentBlocks = select('core/block-editor').getBlocks();
                if (currentBlocks.length !== prevBlocks.length) {
                    setTimeout(() => {
                        initTabs(document);
                        initMobileSelects(document);
                    }, 100);
                    prevBlocks = currentBlocks;
                }
            });

            initTabs(document);
            initMobileSelects(document);
        });
    }

})();
